var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
  'p-2 badge badge-success':
    _vm.documentState.type === 'Approved',
  'p-2 badge badge-warning':
    _vm.documentState.type === 'Waiting',
  'p-2 badge badge-danger':
    _vm.documentState.type === 'Rejected',
}},[_vm._v(" "+_vm._s(_vm.getStateName(_vm.documentState.type))+" "+_vm._s(_vm.documentState.type == "Waiting" ? _vm.documentState.state : "")+" ("+_vm._s(_vm.documentState.lastname)+" "+_vm._s(_vm.documentState.firstname)+") ")])}
var staticRenderFns = []

export { render, staticRenderFns }